//src/lib/assets.ts hardened/refactored v1

// Utility helpers for working with CDN-hosted assets.
const rawBase = import.meta.env.VITE_ASSETS_BASE ?? '';
const ASSETS_BASE = rawBase.replace(/\/+$/, '');

/**
 * Returns a fully qualified asset URL using the configured CloudFront base.
 * Falls back to the original path when the env var is missing.
 */
export const asset = (p: string): string => {
  const normalized = p.startsWith('/') ? p : `/${p}`;
  return ASSETS_BASE ? `${ASSETS_BASE}${normalized}` : normalized;
};
